/**
 * Appends a value with 'px'
 * @returns number 0 or string with px added at end
 */
export default (value): string | number => {
  return value === 0 ? value : `${value}px`;
};
